import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import TopBackButton from '@/component/common/top-back-button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SendMailDrawer from '@/component/auth/send-mail-drawer';
import { fontWeight } from '@/theme';

export default function FindPw() {
  const [email, setEmail] = useState('');
  const [openSendMailDrawer, setOpenSendMailDrawer] = useState(false);

  return (
    <Container sx={{ pb: 5 }}>
      <TopBackButton
        title="비밀번호 찾기"
        boxProps={{
          mb: 4,
        }}
      />
      <Stack direction="row" justifyContent="space-between" mb={3.5} alignItems="center">
        <Typography variant="subtitle2" fontWeight={700}>
          계정 이메일
        </Typography>
      </Stack>
      가입하신 이메일을 입력해 주세요.
      <Box mb={3}>
        <TextField
          id="email"
          autoFocus
          label="email"
          fullWidth
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <Grid item sx={{ mt: 5, mb: 5 }}>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            size="large"
            sx={{
              borderRadius: '100px !important',
            }}
            fullWidth
            onClick={() => setOpenSendMailDrawer(true)}
          >
            <Typography variant="h6" fontWeight={fontWeight.Bold}>
              다음
            </Typography>
          </Button>
        </Grid>
      </Box>
      <SendMailDrawer
        open={openSendMailDrawer}
        email={email}
        password={''}
        type="find"
        onClose={() => setOpenSendMailDrawer(false)}
      />
    </Container>
  );
}
